/**
 * Domain configuration for different environments
 * Shared between frontend and backend
 */

export const getDomainConfig = (isFrontend = false) => {
  // Check if we're in production using VITE_PUBLIC_APP_ENV
  let isProduction;
  
  if (isFrontend) {
    // Frontend: use import.meta.env
    isProduction = import.meta.env.VITE_PUBLIC_APP_ENV === 'production';
  } else {
    // Backend: use process.env
    isProduction = process.env.VITE_PUBLIC_APP_ENV === 'production';
  }
  
  if (isProduction) {
    return {
      domain: 'www.zapt.ai',
      url: 'https://www.zapt.ai',
      environment: 'production'
    };
  } else {
    return {
      domain: 'dev.zapt.ai',
      url: 'https://dev.zapt.ai',
      environment: 'development'
    };
  }
};

export const getAppUrl = (isFrontend = false) => {
  return getDomainConfig(isFrontend).url;
};

// For CommonJS compatibility (Node.js backend)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    getDomainConfig,
    getAppUrl
  };
}



